module.exports = __webpack_public_path__ + "static/rainbowbabycsvest-92d77ed0fb8e9aaf06406e2b20b9066e.jpeg";